import { Button, Col, Row, Table, Modal, Switch, Popconfirm, notification, Spin } from "antd";
import { useEffect, useState } from "react";
import "./style/Complaints.scss";
import { EditOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons';
// import { AddPlanPricing } from "./AddPlanPricing";
import { ADMIN_ROLE, PLANS, ROLE_KEYWORD } from "../../../config/constant";
import { readCookie } from "../../../config/CookieScript";
import { setHeaderName } from "../../../services/SetHeaderName";
import { RaiseTicket } from "./components/RaiseTicket";
import { listOfComplaintsApi } from "../../../config/Api";

export const Complaints = () => {
    // admins don't raise tickets; they see the tickets raised by everyone else
    const isAdmin = readCookie(ROLE_KEYWORD) == ADMIN_ROLE
    const [isModalVisible, setIsModalVisible] = useState(false)
    const [isPlanActive, setIsPlanActive] = useState(false)


    const [dataSource, setDataSource] = useState([]);
    const [displayData, setDisplayData] = useState([]);
    const [isActive, setIsActive] = useState(false)
    const [buttonName, setButtonName] = useState('ADD')
    const [IngredientUnitData, setIngredientUnitData] = useState()
    const [editIngredientUnitRecord, setEditIngredientUnitRecord] = useState()
    const [loading, setLoading] = useState(false)


    const handleOk = () => {
        setIsModalVisible(false);
    };
    const handleCancel = () => {
        setIsModalVisible(false);
    };


    // get the list of all complaints
    const getlistOfComplaints = () => {
        setLoading(true)

        listOfComplaintsApi()
            .then((res) => {
                if (res.status === 200) {
                    setDataSource(res.data.data);
                    setDisplayData(res.data.data);
                    setLoading(false)

                }
            })
            .catch((err) => {
                notification.error({
                    message: 'something went wrong',
                });
                setLoading(false)
            });
    }

    useEffect(() => {
        setHeaderName("Complaints")
        getlistOfComplaints()
    }, []);

    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            // render: (text) => <a>{text}</a>,
        },
        isAdmin && {
            title: 'Raised By',
            dataIndex: 'user',
            key: 'raised_by',
            render: (user) => (
                <>
                    <p className="mb-0">{user?.name}</p>
                    <p className="mb-0 text-muted">{user?.email}</p>
                </>
            ),
        },
        {
            title: 'Title',
            dataIndex: 'title',
            key: 'title',
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
        },
        {
            title: 'Raised On',
            dataIndex: 'created_at',
            key: 'raised_on',
            // render: (text) =>  <p className="mb-0">{text.split('T')[0]}</p>
            // render: (text) =>  <p className="mb-0">{new Date(text).getTime()}</p>
            render: (text) => <p className="mb-0">{text.split('T')[0]}  {new Date(text).toISOString().substr(11, 8)}</p>
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (text) => <p className="mb-0  text-danger">{text}</p>,
        },
    ].filter(Boolean);
    const data = [
        {
            id: '1',
            title: 'John Brown',
            description: 32,
            raised_on: "2022-08-02 14:32:55",
            status: "Raised Successfully"
        },
        {
            id: '2',
            title: 'Jim Green',
            description: 42,
            raised_on: "2022-08-05 14:32:55",
            status: "Raised Successfully"
        },
        {
            id: '3',
            title: 'Joe Black',
            description: 32,
            raised_on: "2022-08-09 14:32:55",
            status: "Raised Successfully"
        },
    ];
    return (
        <>
            <div className="Complaints">
                <Row>
                    {!isAdmin && (
                        <Col md={20} xl={2}>
                            <Button htmlType="submit" className="submit-button  border-0 rounded ms-2 mb-2" icon={<PlusOutlined style={{ fontSize: "1.2rem" }} />} onClick={() => setIsModalVisible(true)}>
                                Raise Ticket
                            </Button>
                        </Col>
                    )}
                    <Col md={isAdmin ? 24 : 4} xl={isAdmin ? 24 : 22} className="text-end align-self-center pe-4">
                        <h6>Total Complaints : {dataSource.length || 0} </h6>
                    </Col>
                </Row>
                <Spin spinning={loading} className="spinner-code">
                    <Row>
                        <Table
                            columns={columns}
                            rowKey="id"
                            dataSource={dataSource}
                            pagination={false}
                            scroll={{ x: "max-content" }}
                            className="w-100"
                        />
                        <Col md={24} xl={24}>
                            <p className="mb-0 text-center mt-2">
                                {isAdmin
                                    ? 'Tickets raised by nutritionists are listed here, newest first.'
                                    : "Tickets will be given status of 'Under Consideration' if it is being resolved."}
                            </p>
                        </Col>
                    </Row>
                </Spin>
            </div>

            <Modal
                open={isModalVisible && !isAdmin}
                footer={null}
                width={900}
                className="addPlanPricing rounded"
                onOk={handleOk} onCancel={handleCancel}
            >
                <RaiseTicket getlistOfComplaints={getlistOfComplaints} setIsModalVisible={setIsModalVisible} />
            </Modal>
        </>
    )
}
